import React, { memo } from 'react';
import StandardTile from '../../general/StandardTile';

interface SearchItemTileProps {
  title: string;
  icon?: React.FC<React.SVGProps<SVGSVGElement> & { title?: string }>;
  children: React.ReactNode;
  collapsible?: boolean;
  initialCollapsed?: boolean;
  className?: string;
  leftSide?: {
    link: string,
    onClick?: () => void
  };
  extraInfoValues?: any;
  renderValue?: any;
  style?: React.CSSProperties;
}

const SearchItemTile = ({
  title,
  icon,
  children,
  collapsible = false,
  initialCollapsed = false,
  className = '',
  leftSide,
  extraInfoValues,
  renderValue,
  style,
}: SearchItemTileProps) => {
  return (
    <StandardTile
      title={title}
      leftIcon={icon ? () => icon({ title }) : undefined}
      collapsible={collapsible}
      initialCollapse={initialCollapsed}
      titleClassname={className}
      leftSide={leftSide}
      extraInfoValues={extraInfoValues}
      renderValue={renderValue}
      style={style}
    >
      {children}
    </StandardTile>
  );
};

export default memo(SearchItemTile);